import React from 'react'
import { AboutMeCoverImage, AboutMeForm, AboutMe } from '../allsite/AboutMe'

const PAGE_KEY = 'ABOUT_ME_CONTACT'
export default function AboutMeSection() {
    return (
        <AboutMe pageKey={PAGE_KEY}>
            <div className="columns is-vcentered">
                <div className="column is-narrow">
                    <h1 className="is-size-3 title">About me</h1>
                    <h2 className="is-size-6 subtitle">Describe yourself for your &ldquo;Contact Me&rdquo; page</h2>
                </div>
            </div>
            <div className="columns">
                <div className="column is-5">
                    <AboutMeCoverImage />
                </div>
                <div className="column">
                    <AboutMeForm contentRows={20} />
                </div>
            </div>
        </AboutMe>
    )
}
